import * as atlas from 'azure-maps-control';
import React, { useContext, useMemo } from 'react';
import '../../../style/Map.scss';
import { StockLocationContext } from '../../../context/StockLocationContext';
import { Marker, MarkerLayer, ClusterLayer } from '.';
import { MobileStockLocationSessionContext } from '../../../context/MobileStockLocationSessionContext';
import VentoryMap from './Map';

// TODO: MAKE SURE TO REMOVE THE OLD SESSION IF A NEW SESSION COMES

interface StockLocationMapProps<M extends Marker> {
  clusterLayer?: ClusterLayer<M>;
  markerLayer: MarkerLayer<M>;
  stockLocationIds: Set<string>;
  onMapReady?: (map: atlas.Map) => void;
}

export default function StockLocationMap<M extends Marker>({
  stockLocationIds,
  markerLayer,
  clusterLayer,
  onMapReady,
}: StockLocationMapProps<M>) {
  const { stockLocations } = useContext(StockLocationContext);
  const { sessions } = useContext(MobileStockLocationSessionContext);

  const markers = useMemo(() => {
    return new Map(
      [...stockLocationIds].map(id => {
        const session = [...sessions.values()].find(s => s.stockLocationId === id);
        const marker = markerLayer.markerBuilder(stockLocations.get(id)!, session);
        return [marker.id, marker];
      }),
    );
  }, [stockLocations, sessions]);

  return <VentoryMap markerLayer={markerLayer} clusterLayer={clusterLayer} markers={markers} />;
}
